import {FC} from 'react'
import {useIntl} from 'react-intl'
import {Link, useLocation} from 'react-router'

import RunMeter from './RunMeter'
import {useRunDriver} from './runDriverContext'
import {PAGE_URL, noticePhase} from './types'

/**
 * A small notice on the portal's other pages about the run this tab drives: going, waiting on
 * the user, or done. Hidden where the run's own page shows it, and once the user hides it.
 */
const RunNotice: FC = () => {
  const intl = useIntl()
  const {pathname} = useLocation()
  const {run, driving, inFlight, queued, seen, pause, markSeen} = useRunDriver()
  if (!run) return null

  const runUrl = `${PAGE_URL}/runs/${run.id}`
  const onRunPage = [PAGE_URL, `${PAGE_URL}/`, runUrl].includes(pathname)
  const phase = noticePhase(run, driving)
  const key = `${run.id}:${phase}`
  if (onRunPage || !phase || seen === key) return null

  const text = (id: string) => intl.formatMessage({id: `FEE.GENERATE_VOUCHERS.${id}`})

  // Clear of the sidebar and the chatbot's corner; above them on a phone.
  return (
    <div
      className='position-fixed bottom-0 start-50 translate-middle-x mb-20 mb-lg-5'
      style={{zIndex: 105, width: 'min(26rem, calc(100vw - 2rem))'}}
      role='status'
    >
      <div className='card shadow'>
        <div className='card-body px-5 py-4'>
          <div className='d-flex align-items-center'>
            <span className='fw-bold me-auto'>{text(`NOTICE.${phase}`)}</span>
            {driving && (
              <button
                type='button'
                className='btn btn-sm btn-light-warning py-1 px-3 me-2'
                onClick={pause}
              >
                {text('RUN.PAUSE')}
              </button>
            )}
            <Link to={runUrl} className='btn btn-sm btn-light-primary py-1 px-3 me-3'>
              {text('RUN')}
            </Link>
            <button
              type='button'
              className='btn-close'
              aria-label={intl.formatMessage({id: 'GENERAL.HIDE'})}
              onClick={() => markSeen(key)}
            />
          </div>
          <RunMeter run={run} inFlight={inFlight} queued={queued} compact />
        </div>
      </div>
    </div>
  )
}

export default RunNotice
